import validator from "validator";
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowRight, faCircleArrowLeft } from '@fortawesome/free-solid-svg-icons';

const Passions = ({ nextStep, handleFormData, prevStep, values } ) =>
{
    //creating error state for validation
    const [ error, setError ] = useState( false );

    // after form submit validating the form data using validator
    const submitFormData = ( e ) =>
    {
        e.preventDefault();

        // checking if value of first name and last name is empty show error else take to step 2
        if( !e.target.passions
        ) {
            setError( true );
        } else {
            console.log(e.target.value)
            // nextStep();
        }
    };
    return (
    <div className="form-container">
            <form className="body" onSubmit={submitFormData}>
                <div className="header">
                    <h1>Passions</h1>
                </div>
                <div className="sign-up-container">
                    <div className="buttons-container">
                        <button className="passion"
                            onClick={handleFormData( 'passions' )}
                            name="passions">Foodie</button>
                        <button className="passion">Walking</button>
                        <button className="passion">Baking</button>
                        <button className="passion">Running</button>
                        <button className="passion">Travel</button>
                        <button className="passion">Blogging</button>
                        <button className="passion">Movies</button>
                        <button className="passion">Reading</button>
                        <button className="passion">Photography</button>
                        <button className="passion">Photography</button>
                        <button className="passion">Sports</button>
                        <button className="passion">Surfing</button>
                        <button className="passion">Fashion</button>
                        <button className="passion">Coffee</button>
                        <button className="passion">Karaoke</button>
                        <button className="passion">Astrology</button>
                        <button className="passion">Gaming</button>
                        <button className="passion">Cooking</button>
                        <button className="passion">Sewing</button>
                        <button className="passion">Spirituality</button>
                        <button className="passion">DIY</button>
                        <button className="passion">Politics</button>
                        <button className="passion">Cycling</button>
                        <button className="passion">Museums</button>
                        <button className="passion">Outdoors</button>
                        <button className="passion">Shopping</button>
                        <button className="passion">Comedy</button>
                        <button className="passion">Brunch</button>
                        <button className="passion">Music</button>
                        <button className="passion">DOG LOVER</button>
                        <button className="passion">Board Games</button>
                        <button className="passion">Volunteering</button>
                        <button className="passion">Environmentalism</button>
                        <button className="passion">Hiking</button>
                    </div>
                </div>
                    {error ? (
                        <div className='error-container'>
                            <p className="errorText">
                                Please make a selection.
                            </p>
                        </div>
                    ) : (
                        ""
                    )}
                <div className="footer">
                    <button className="next" type="submit">
                        <FontAwesomeIcon icon={faCircleArrowRight} size="lg" color="#fefefe" />
                    </button>
                    <button className="prev" onClick={prevStep}>
                        <FontAwesomeIcon icon={faCircleArrowLeft} size="lg" color="#fefefe" />
                    </button>
                </div>
            </form>
    </div >
)
}

export default Passions